
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"15","height":"15","viewBox":"0 0 15 15"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M7.522.832c.695.435.651 2.91.651 2.91v2.26l.87.738s-.044-.174-.088-.391C8.955 6.132 9 6 9 5.958c0-.044.043-.044.043-.044h.521c.044 0 .044.044.044.044s.043.087.043.347-.087.478-.087.478h-.087v.26l3.519 2.868.087.869-.087-.13-3.432-1.651-1.39-.304v1.346c0 1-.26 1.955-.26 1.955l1.39 1.173v.651L7.826 13.3v.043c0 .044-.044.218-.044.218h-.087l-.13.434h-.043v.174l-.044-.13h-.043l-.13-.435h-.087s-.044-.217-.044-.304v-.043l-1.477.52v-.65l1.39-1.174s-.26-.955-.26-1.954V8.65l-1.39.304-3.432 1.65-.087.131.087-.869L5.524 7l-.087-.304H5.35s-.087-.217-.087-.477.043-.348.043-.348 0-.043.044-.043h.521s.043 0 .043.043.044.174.044.391c0 .217-.087.39-.087.39l.869-.738V3.743c.13 0 .087-2.476.782-2.91z"}})])
          )
        }
      }
    